export enum NotificationType {
    LISTENED_WITH = 0,
    LIKED = 1,
    FOLLOWED = 2,
    NOTES_ADDED = 3
}